/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import primaryNavModule from "jrs-ui/src/actionModel/actionModel.primaryNavigation";
import DashboardReportNavigation from "bi-dashboard/src/dashboard/DashboardReportNavigation";
import _ from 'underscore';

_.extend(primaryNavModule, {
    bodyIds: _.extend({}, primaryNavModule.bodyIds, {
        'dashboard': DashboardReportNavigation.confirmAndLeave
    })
});

export default primaryNavModule;
